import { createForm } from '@seek/forms-ui';
import { Box } from 'braid-design-system';
import { observer } from 'mobx-react';
import type { Locale } from '@seek/melways-sites';
import type { IJobApplicationStore } from '../../../stores/JobApplicationStore';
import AddCandidateFormFields from './AddCandidateFormFields';
import type { CandidateAttachment } from './types';

export interface FormValues {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  mostRecentJobTitle: string;
  mostRecentCompanyName: string;
  timeInRoleYears: string;
  timeInRoleMonths: string;
  notes: string;
  originId: string;
}

export enum ADD_CANDIDATE_FORM_FIELD_NAMES {
  EMAIL = 'email',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  PHONE = 'phone',
  MOST_RECENT_JOB_TITLE = 'mostRecentJobTitle',
  MOST_RECENT_COMPANY_NAME = 'mostRecentCompanyName',
  TIME_IN_ROLE_YEARS = 'timeInRoleYears',
  TIME_IN_ROLE_MONTHS = 'timeInRoleMonths',
  NOTES = 'notes',
  ORIGIN_ID = 'originId',
}

const initFormValues = {
  email: '',
  firstName: '',
  lastName: '',
  phone: '',
  mostRecentJobTitle: '',
  mostRecentCompanyName: '',
  timeInRoleYears: '',
  timeInRoleMonths: '',
  notes: '',
  originId: '',
};
export interface CandidateFormValues extends FormValues {
  resume: CandidateAttachment | null;
  coverLetter: CandidateAttachment | null;
}

export type AddCandidate = (values: CandidateFormValues) => Promise<void>;

const { FormProvider, useField } = createForm<FormValues>();

interface ProviderProps {
  jobApplicationStore: IJobApplicationStore;
  locale: Locale;
  onClose?(): void;
  addCandidate: AddCandidate;
}

const AddCandidateForm = observer(
  ({ jobApplicationStore, onClose, locale, addCandidate }: ProviderProps) => (
    <Box>
      <FormProvider language={locale} initialValues={initFormValues}>
        {({ handleSubmit, setFieldValue, resetForm }) => (
          <AddCandidateFormFields
            handleSubmit={handleSubmit}
            setFieldValue={setFieldValue}
            resetForm={resetForm}
            addCandidate={addCandidate}
            jobApplicationStore={jobApplicationStore}
            useField={useField}
            onClose={onClose}
          />
        )}
      </FormProvider>
    </Box>
  ),
);

export default AddCandidateForm;
